import {action, useStrict, extendObservable, toJS, spy, isObservableObject} from 'mobx'
useStrict(true)

const DEBUG = false

spy((event) => {

  if (!DEBUG) return

  if (event.type === 'action') {
    const actionName = event.name.replace("bound ", "")
    const args = event.arguments.map( (o)=> isObservableObject(o) ? toJS(o) : o )
    console.log(`ACTION: ${actionName}`, ...args)
  } 
})

export class Store {

  constructor(state, actions={}, reactions={}) {
    this.initialState = state
    this.action = {
      ...actions,
      setValues(values) {
        for (let key in values) {
          if (this.hasOwnProperty(key))
            this[key] = values[key]
        }
      },
    }
    this.reaction = {}

    extendObservable(this, state)

    for (let key in actions) {
      if (actions.hasOwnProperty(key))
        this.action[key] = action(actions[key].bind(this))
    }

    for (let key in reactions) {
      if (reactions.hasOwnProperty(key)) {
        const reactionFunc = reactions[key].bind(this)
        this.reaction[key] = reactionFunc
        reactionFunc()
      }
    }
  }

  toJS() {
    return toJS(this)
  }

  transaction(actionFunc) {
    return action(actionFunc)()
  }

}

export const createStoreClass = (state, actions, reactions)=> {
  return class NewStore extends Store {
    constructor(initialState) {
      super(state, actions, reactions)
      this.initialState = initialState
    }
  }
}

export const createStore = (state, actions, reactions)=> {
  return new Store(state, actions, reactions)
}


// WEBPACK FOOTER //
// ./src/lib/store/index.js